import { get } from "api/axiosApi";
import { env } from "utils/env";

const url = env.REACT_APP_LEASING_API_URL; //"http://kube-w1:32751/api";

const getUserGroups = () => {
  return get(url + "/user/userGroups");
};
const exp = {
  getUserGroups
};
export default exp;
